const initialState = {
    upload_image : null,
    special_link : null,
    liability_waiver_modal : false,
    is_add_on : false,
    park : null,

    // for promotion code
    remaining_promo_tickets : null,
    price_calculating : false,

    // capacity
    is_capacity : false,
    remaining_capacity : 0,
    capacity : null,

    // for integration pazzport
    ticket_saveable : true,

    // preference
    preference_groups : [],

    // auto set promotion code
    default_promo_code : null,
}

const ticketReducer = (state = initialState, action) => {
	switch(action.type){
		case 'UPLOAD_IMAGE':
			return {...state, upload_image : action.image};
		case 'SET_SPECIAL_LINK':
			return {...state, special_link : action.special_link};
		case 'SET_LIABILITY_WAIVER':
			return {...state, liability_waiver_modal : action.liability_waiver_modal};
		case 'SET_IS_ADD_ON':
			return {...state, is_add_on : action?.is_add_on};
		case 'SET_PARK':
			return {...state, park : action?.park};
		case 'SET_REMAINING_PROMO_TICKETS':
			return {...state, remaining_promo_tickets : action?.remaining_promo_tickets, price_calculating : false};
		case 'PRICE_CALCULATING':
			return {...state, price_calculating : action.loading};
		case 'SET_TICKET_SAVEABLE':
			return {...state, ticket_saveable : action.ticket_saveable};
		case 'SET_CAPACITY':
			return {...state, remaining_capacity : action?.remaining_capacity, is_capacity : action?.is_capacity, capacity : action?.capacity};
		case 'SET_PREFERENCE':
			return {...state, preference_groups : action?.preference_groups};
		case 'SET_DEFAULT_PROMO_CODE':
			return {...state, default_promo_code : action?.promo_code};
		case 'SET_AVAILABLE_ADD_ONS':
			return {...state, available_add_ons: action.available_add_ons};
		case 'SET_ADD_ON_APPLICABLE_TICKET_USER':
			return {...state, add_on_applicable_ticket_user: action.add_on_applicable_ticket_user};
		default:
			return state;
	}
};


export default ticketReducer;